module.exports = __webpack_public_path__ + "img/img_02.c22d5ed0.jpg";